import { PageHeader, SubNav } from '@/components/ui/page';

const ITEMS = [
  { to: '/reports', label: 'Sources', end: true },
  { to: '/reports/funnel', label: 'Funnel' },
  { to: '/reports/campaigns', label: 'Campaigns' },
];

/** The Reports header and its tabs, shared by the three report pages (ATT-1…5, LEAD-4). */
const ReportsHeader = () => (
  <>
    <PageHeader title="Reports" description="Where leads come from, how they move from lead to sale, and which campaigns bring them." />
    <SubNav label="Reports" items={ITEMS} />
  </>
);

export default ReportsHeader;
